import React, {Component} from "react";
import {connect} from "react-redux";
import './MFASetup.scss';
import { InputV3, ButtonV3 } from 'react-ui-lib';
class MFASetup extends Component {

  constructor(props) {
		super(props);
		this.state ={
      renderState: 'verificationView',
      errorMsg : '',
      verificationCode:'',
      qrCode:''
		}
  }
  
	handleChange = (e) => {
    var verificationCode = e.target.value ? e.target.value.trim() : "";
    this.setState({
      verificationCode
    });
	};
	
	validateCode = (e) => {
    e.preventDefault();
    const { verificationCode } = this.state;
    if (verificationCode && verificationCode){
      let payload = {
        stage: 'QRCode',
        otc : verificationCode
      }      
      this.props.doValidateOTC(payload,this.emailCodeValidatedCB, ()=>{
        this.handleFlashMessage("Invalid verification code. Please try again.","error");
      });
    }
    else{
      this.handleFlashMessage("Please enter verification code sent to your email", "error");
    }
  };

  emailCodeValidatedCB = (data, res) =>{
    if(this.timeoutId){
      clearTimeout(this.timeoutId);
      this.setState({'errorMsg':''});
    }   
    this.setState({
      renderState : 'qrCodeView',
      qrCode:res.qrCode
    })
  }
  
	handleFlashMessage = (data,notifyType) =>{

    this.setState({'errorMsg':data});
    this.timeoutId = setTimeout(()=>{  
      this.setState({'errorMsg':''});
    },3000);
	}

  handleKeypress(e){
    if (e.key === "Enter") {
      this.validateCode()
    }
	}
	
	renderMFaVerificationView = () => {
    const { verificationCode, errorMsg } = this.state;
    return (
      <form onSubmit={this.validateCode}>
        <h1 className="header" ref={welHElm => this.welcomeHeader = welHElm}>2FA Setup!</h1>
        <span className="loginSubHeader" ref={welSHElm => this.welcomeSubHeader = welSHElm}>Please enter verification code sent to your email.</span>
        <div className="row" style={{ marginBottom: '2em' }}>
          <div className="col">
            <InputV3
              label="Verification code"
              name="verificationCode"
              placeholder="Enter your Verification code..."
              bgcolor="white"
              width="100%"
              spellCheck="false" 
              onChange = {this.handleChange}
              defaultValue = {verificationCode}
              autoFocus={true}
              type="text"
              errorMessage = {errorMsg}
              inputstyle={{ width: '100%', padding: '1.2em 1em', height: 'auto' }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <ButtonV3
              btnstyle={{ width: '100%', padding: '1.2em', height: 'auto' }}
              key='Validate' 
              name="Validate"
              type="submit"
              disabled={verificationCode.length ? false : true}
            />
          </div>
        </div>
      </form>
    )
	};

	renderQRCodeView = () =>{
		return (

      <div>
        <h3 className="loginHeader" ref={welHElm => this.welcomeHeader = welHElm}>2FA Setup!</h3>
        <h3 className="loginSubHeader color-green" ref={welSHElm => this.welcomeSubHeader = welSHElm}>Verification successful! Now please scan the QR code using the Authenticator mobile app to setup 2-Factor Authentication on your account.</h3>
        <div className="row" style={{ marginBottom: '2em' }}>
          <div className="col">
            <div className="col-lg-12 col-md-12 col-sm-12 login-input-box" style={{textAlign:'center'}}>
			 		    {/* <img src="data:image/png;base64,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" alt="qr code"/> */}
              <img src={this.state.qrCode} alt="QR code" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <ButtonV3
              btnstyle={{ width: '100%', padding: '1.2em', height: 'auto' }}
              name="Go to Sign In"
              onClick={this.props.onLoginClickedFromQrCode}
            />
          </div>
        </div>
      </div>
		)
	}

	render() {
		const {renderState} = this.state;
		// let options = {
		// 	showAgent : false,
		// 	isTutorialAvail : false,
		// 	logoRouteVal : "/",
		// 	showUserDetail : false,
		// 	showUserSetting : false,
		// 	showGoLive : false,
		// 	isShowFBLive: false
		// }
		return (
			<div>
					{
						renderState === 'qrCodeView' ?
							this.renderQRCodeView()
						:
							this.renderMFaVerificationView()
					}			
			</div>
		)
	}  
}

export default connect(null, null)(MFASetup);